var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBecomeABroker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7588)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9708 18.9714C18.9708 16.9769 20.5877 15.36 22.5822 15.36C24.5768 15.36 26.1937 16.9769 26.1937 18.9714C26.1937 20.966 24.5768 22.5828 22.5822 22.5828C20.5877 22.5828 18.9708 20.966 18.9708 18.9714ZM15.3594 30.7086C15.3594 26.7195 18.5932 23.4857 22.5822 23.4857C25.8587 23.4857 28.6256 25.6673 29.5096 28.6571C27.2003 28.9815 25.4235 30.9652 25.4235 33.364V38.1438C25.4235 38.9368 25.6177 39.6846 25.9612 40.3419C25.795 40.526 25.5548 40.64 25.2908 40.64H19.8737C19.4211 40.64 19.0385 40.305 18.9787 39.8565L18.1803 33.8686H16.2622C15.7636 33.8686 15.3594 33.4643 15.3594 32.9657V30.7086ZM33.5619 29.4668C33.1879 29.4668 32.8847 29.77 32.8847 30.1439V30.8678H35.4355V30.1439C35.4355 29.77 35.1323 29.4668 34.7583 29.4668H33.5619ZM30.6276 30.1439V30.8678H30.1768C28.7982 30.8678 27.6806 31.9854 27.6806 33.364V38.1438C27.6806 39.5224 28.7982 40.64 30.1768 40.64H38.1432C39.5218 40.64 40.6394 39.5224 40.6394 38.1438V33.364C40.6394 31.9854 39.5218 30.8678 38.1432 30.8678H37.6926V30.1439C37.6926 28.5234 36.3788 27.2097 34.7583 27.2097H33.5619C31.9413 27.2097 30.6276 28.5234 30.6276 30.1439Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7588",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeABroker);
export default __webpack_public_path__ + "static/media/become_a_broker.b1200af3d2c648363679cbfc10885853.svg";
export { ForwardRef as ReactComponent };